import "../../../styles/app.scss";
import "../../../styles/header.scss";
import ThreeDots from "../../../assets/images/icons/three-dots.svg";
import { Translate } from "react-localize-redux";
import BaseButton from "wallet-elementkit/dist/elementKit/baseButton/BaseButton";
import MenuSheet from "../../menuSheet/MenuSheet";
import WelcomeSheet from "../../welcomeSheet/WelcomeSheet";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom";
import { SearchBox } from "wallet-elementkit/dist/components";
import Logo from "../../../assets/images/logos/verified-logo.png";
import BySertifierLogo from "../../../assets/images/logos/by-sertifier-logo.png";
import { ReactComponent as ArrowBack } from "../../../assets/common/arrow-back.svg";
import { useAppSelector } from "../../../store/hooks";
import { selectUser } from "../../../store/features/user";
import ConditionalWrapper from "../ConditionalWrapper";
import { configFallback } from "wallet-elementkit/dist/constants/master";

const HeaderWeb = (props) => {
	const history = useHistory();
	const userMeta = useAppSelector(selectUser);
	return (
		<div
			className="flex-column header-main-out"
			style={{
				backgroundColor: props.config.headerBackgroundColor,
			}}
		>
			<div className="flex-row jc-sb header-main">
				{props.backButton.backButtonEnabled ? (
					<ConditionalWrapper
						condition={
							!props.backButton.onClickAction &&
							props.backButton.redirectUrl != null
						}
						wrapper={(children) => {
							return (
								<Link
									to={
										!props.backButton.onClickAction &&
										props.backButton.redirectUrl
											? props.activeLanguage
												? `/${props.activeLanguage.code}/${props.backButton.redirectUrl}`
												: `/en/${props.backButton.redirectUrl}/}`
											: props.activeLanguage
											? `/${props.activeLanguage.code}/profile/${props.userMeta.user.username}/`
											: `/en/profile/${props.userMeta.user.username}/`
									}
								>
									{children}
								</Link>
							);
						}}
						children={
							<BaseButton
								type="secondary"
								size="small"
								loading={false}
								height={35}
								width={175}
								onClickAction={props.backButton.onClickAction}
								className="back-button"
							>
								<div className="flex-row jc-sb">
									<ArrowBack className="arrow-back customizable-icon" />
									<Translate
										id={props.backButton.buttonTextKey || "backToHomepage"}
									/>
								</div>
							</BaseButton>
						}
					/>
				) : props.config.logoLink === configFallback.logoLink ? (
					<div className="flex-row ai-fe">
						<ConditionalWrapper
							condition={true}
							wrapper={(children) =>
								userMeta.logged ? (
									<Link
										to={
											userMeta.logged
												? props.activeLanguage
													? `/${props.activeLanguage.code}/profile/${userMeta.user.username}/`
													: `/en/profile/${userMeta.user.username}/`
												: props.activeLanguage
												? `/${props.activeLanguage.code}/`
												: "/en/"
										}
									>
										{children}
									</Link>
								) : (
									<a
										href={
											props.config.logoRedirectUrl.includes("http")
												? props.config.logoRedirectUrl
												: `http://${props.config.logoRedirectUrl}`
										}
										target="_blank"
										rel="noreferrer"
									>
										{children}
									</a>
								)
							}
							children={
								<img
									alt="Verified by Sertifier Logo"
									src={Logo}
									className="verified-logo"
									height={26.261}
								/>
							}
						/>
						<a
							href="https://sertifier.com"
							target="_blank"
							rel="noreferrer"
							className="by-sertifier-wrapper"
						>
							<img
								src={BySertifierLogo}
								alt="By Sertifier Logo"
								className="by-sertifier-logo"
								height={15.631}
							/>
						</a>
					</div>
				) : (
					<a
						href={
							(!props.config.logoRedirectUrl ||
								props.config.logoRedirectUrl ===
									configFallback.logoRedirectUrl) &&
							props.config.website
								? props.config.website
								: props.config.logoRedirectUrl.includes("http")
								? props.config.logoRedirectUrl
								: `http://${props.config.logoRedirectUrl}`
						}
						target="_blank"
						rel="noreferrer"
					>
						<img
							alt="Verified"
							src={props.config.logoLink}
							className="org-logo"
							style={{ cursor: "pointer", marginRight: "auto" }}
						/>
					</a>
				)}
				{props.config.headerMenu?.length ? (
					<div className="menu-items">
						{props.config.headerMenu.map((item) => (
							<a
								href={item.link}
								target="_blank"
								rel="noreferrer"
								className="single-menu-item customizable-text"
							>
								{item.text}
							</a>
						))}
					</div>
				) : null}
				{props.userMeta.logged && (
					<SearchBox
						historyPush={history.push}
						activeLanguage={props.activeLanguage}
						translate={props.translate}
						isMobile={false}
						addTranslation={props.addTranslation}
						isLogged={userMeta.logged}
					></SearchBox>
				)}
				<div className="flex-row">
					{props.config.contactEmail ? (
						<>
							<BaseButton
								type="secondary"
								size="small"
								height={35}
								styles={{
									borderColor: props.config.primaryColor,
								}}
								onClickAction={props.handleContact}
							>
								<span
									className="s7"
									style={{ color: props.config.primaryColor }}
								>
									<Translate id="contact" />
								</span>
							</BaseButton>
							<div style={{ width: "20px" }} />
						</>
					) : null}
					{props.config.headerButtonUrl ? (
						<a
							href={
								props.config.headerButtonUrl.includes("http")
									? props.config.headerButtonUrl
									: `http://${props.config.headerButtonUrl}`
							}
							target="_blank"
							style={{ marginRight: "20px" }}
							rel="noreferrer"
						>
							<BaseButton
								type="secondary"
								size="small"
								height={35}
								backgroundColor={props.config.headerButtonBackgroundColor}
								styles={{
									width: "fit-content",
									borderColor: props.config.primaryColor,
								}}
							>
								<span
									className="s7"
									style={{
										color:
											props.config.headerButtonTextColor ||
											props.config.primaryColor,
										width: "fit-content",
									}}
								>
									{props.config.ctaText ? (
										props.config.ctaText
									) : (
										<Translate id="visitWebsite" />
									)}
								</span>
							</BaseButton>
						</a>
					) : null}
					{!props.backButton.backButtonEnabled &&
						(props.userMeta.logged ? (
							<div
								className="account-modal-icon-container"
								onClick={() => {
									props.setAccountModalOpen((prevState) => !prevState);
								}}
							>
								<img
									className="account-modal-icon"
									alt="Verified Account Modal"
									src={ThreeDots}
									height="10"
									width="30"
								/>
							</div>
						) : (
							<div
								className="account-modal-icon-container"
								onClick={() => {
									props.setAccountModalOpen((prevState) => !prevState);
								}}
							>
								<BaseButton
									type="primary"
									size="small"
									height={35}
									backgroundColor={props.config.primaryColor}
									loading={false}
								>
									<Translate id="account" />
								</BaseButton>
							</div>
						))}
				</div>
			</div>
			{props.accountModalOpen &&
				(props.userMeta.logged ? (
					<MenuSheet
						isMobile={false}
						sheetOpen={props.accountModalOpen}
						userMeta={props.userMeta}
						onClose={props.handleModalClose}
						translate={props.translate}
						config={props.config}
					/>
				) : (
					<WelcomeSheet
						isMobile={false}
						sheetOpen={props.accountModalOpen}
						onClose={props.handleModalClose}
						config={props.config}
					/>
				))}
		</div>
	);
};

export default HeaderWeb;
